export default __webpack_public_path__ + "static/hop_radler-d36eef38c00263b63fe7261c4026a0cc.png";